export default __webpack_public_path__ + "static/media/1.404fe8f8.jpg";